import { cn } from '@/shared/lib/utils'

const EU_COMMISSION_FLAG_IMAGE_URL =
  'https://upload.wikimedia.org/wikipedia/commons/8/8b/Europe_flag_circle.png'

type EuCommissionAvatarProps = {
  className?: string
}

export function EuCommissionAvatar({ className }: EuCommissionAvatarProps) {
  return (
    <div
      className={cn(
        'size-10 shrink-0 overflow-hidden rounded-full',
        className
      )}
      aria-hidden
    >
      <img
        src={EU_COMMISSION_FLAG_IMAGE_URL}
        alt=''
        className='size-full object-cover'
      />
    </div>
  )
}
